import React from "react";
import PropTypes from "prop-types";

const ArrowIcon = (props) => {
    return (props.listOpen ? 
        <i className="ion-ios-arrow-up"/> : 
        <i className="ion-ios-arrow-down"/>);
}

ArrowIcon.propTypes = {
    listOpen: PropTypes.bool.isRequired
}


export default ArrowIcon;